<template>
  <div class="header-meta">
    <div class="container">
      <div class="header-meta-body">
        <div>
          <a
            href="https://www.uni-hamburg.de/newsroom/presse.html"
            class="header-meta-link"
          >
            Presse
          </a>
          <a
            href="https://www.kus.uni-hamburg.de/de.html"
            class="header-meta-link"
          >
            KUS-Portal
          </a>
          <a
            href="https://www.stine.uni-hamburg.de"
            class="header-meta-link"
          >
            Stine
          </a>
        </div>
        <div>
          <router-link to="/" class="header-meta-link end">
            Karte
          </router-link>
          <a
            href="/Admin"
            class="header-meta-link end"
          >
            Login
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'HeaderMeta',
};
</script>

<style scoped>
.header-meta {
  background: #027bcb;
  color: #fff;
  width: 100%;
  height: 30px;
  font-family: TheSansUHH-Caps, sans-serif;
}

.header-meta-body {
  padding-top: 2px;
  margin: 0 20px;
  display: flex;
  justify-content: space-between;
}

.header-meta-link {
  margin-left: 18px;
  text-decoration: none;
  cursor: pointer;
  color: #fff;
}

.header-meta-link:first-child {
  margin-left: 0;
}

.header-meta-link:hover {
  text-decoration: underline;
}
</style>
